import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f8a6828e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f8a6828e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a6828e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a6828e')) {
      api.createRecord('f8a6828e', component.options)
    } else {
      api.reload('f8a6828e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f8a6828e&scoped=true&", function () {
      api.rerender('f8a6828e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UJ7l0j7NZryz/JS/comp/SearchFilterTokens.vue"
export default component.exports